import i18n from "i18next";

import type { TargetJoints } from "api/services/content/schemas/shared";
import type { Joint } from "api/types/GetActivityLibraryEntriesArgs";

interface Args {
  painLocation: Joint | TargetJoints;
  plural?: boolean;
}

export const translatePainLocation = ({ painLocation, plural = false }: Args): string => {
  const count = !plural ? 1 : 2;

  const keyMap: Record<Joint | TargetJoints, string> = {
    back: i18n.t("patients.pain_location.back_icu", { count }),
    chest: i18n.t("patients.pain_location.chest_icu", { count }),
    elbow: i18n.t("patients.pain_location.elbow_icu", { count }),
    fall_prevention: i18n.t("patients.pain_location.fall_prevention_icu", { count }),
    foot: i18n.t("patients.pain_location.foot_icu", { count }),
    hand: i18n.t("patients.pain_location.hand_icu", { count }),
    hip: i18n.t("patients.pain_location.hip_icu", { count }),
    jaw: i18n.t("patients.pain_location.jaw_icu", { count }),
    knee: i18n.t("patients.pain_location.knee_icu", { count }),
    lower_back: i18n.t("patients.pain_location.lower_back_icu", { count }),
    lower_leg: i18n.t("patients.pain_location.lower_leg_icu", { count }),
    neck: i18n.t("patients.pain_location.neck_icu", { count }),
    neuro: i18n.t("patients.pain_location.neuro_icu", { count }),
    osteoporosis: i18n.t("patients.pain_location.osteoporosis_icu", { count }),
    pelvic_floor: i18n.t("patients.pain_location.pelvic_floor_icu", { count }),
    shoulder: i18n.t("patients.pain_location.shoulder_icu", { count }),
    spine: i18n.t("patients.pain_location.spine_icu", { count }),
    upper_back: i18n.t("patients.pain_location.upper_back_icu", { count }),
    wrist: i18n.t("patients.pain_location.wrist_icu", { count }),
  };

  return keyMap[painLocation] || painLocation;
};
